import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { TitleChangerInterface } from "./titleChanger.interface";

const localUrl = "/assets/data/titleChanger.json";
@Injectable()
export class TitleChangerResolver  {
  constructor(private router: Router, private http: HttpClient) {}
  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    let data = route.data["category"];
    return this.http
      .get<TitleChangerInterface[]>(localUrl)
      .pipe(map((x) => x[data]));
  }
}
